module.exports = __webpack_public_path__ + "static/img/4.1cd3b5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/welcome/4.png
// module id = 09Y6
// module chunks = 0